import { gql } from 'graphql-request';

export const getModelRunsTableAssetsQuery = gql`
  query GetModelRunsTableAssets(
    $filters: TableAssetFilters
    $assetFilters: [Filter!]
    $sort: AssetFieldPaginationSort
    $cursor: String
    $limit: Int!
    $daysBack: Int!
  ) {
    tableAssets(
      filters: $filters
      assetFilters: $assetFilters
      sort: $sort
      cursor: $cursor
      limit: $limit
      daysBack: $daysBack
    ) {
      items {
        id
        name
        dbName
        schemaName
        materialization
        tags
        owners
        subscribers
        path
        isCritical
        latestExecution(ignoreSkippedRuns: false) {
          status
          executionTime
          executionTimestamp
        }
        performanceStats(daysBack: $daysBack) {
          medianDuration
          changeRate
          successCount
          errorCount
        }
      }
      pageInfo {
        hasNextPage
        nextCursor
      }
    }
  }
`;

export const getModelRunsAssetsFilterOptionsQuery = gql`
  query GetModelRunsAssetsFilterOptions(
    $filters: TableAssetFilters
    $assetFilters: [Filter!]
  ) {
    tableAssetsFilterOptions(filters: $filters, assetFilters: $assetFilters) {
      field
      options {
        value
        count
      }
    }
  }
`;

export const getModelExecutionHistoryQuery = gql`
  query GetModelExecutionHistory(
    $id: String!
    $startTime: DateTime!
    $endTime: DateTime!
  ) {
    tableAsset(id: $id) {
      executionHistory(startTime: $startTime, endTime: $endTime) {
        id
        executionTimestamp
        executionTime
        status
        isFullRebuild
      }
    }
  }
`;
